import React from "react";
import { NavLink } from "react-router";
import { useNavigate } from "react-router-dom";
import { RoutesPaths } from "../Router/constant";
import { useTranslation } from "react-i18next";

export default function Notfound() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const redirectContactUs = () => {
    navigate(RoutesPaths.CONTACTUS);
  };
  return (
    <div className="notFound commonHeaderPadding">
      <div className="main-container whoWeAreSectionPadding">
        <div className="row">
          <div className="col-md-6">
            <div>
              <img
                src="/images/404.webp"
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-md-6 notFoundLeftSectionCol">
            <div className="notFoundLeftSection">
              <h2 className="m-0 f-s-48 l-h-60 fw-semibold">Ooops...</h2>
              <h2 className="m-0 f-s-48 l-h-60 fw-semibold">Page not found </h2>
              <p className="m-0 f-s-20 l-h-30">
                Sorry, the page you're looking for doesn't exist or may have
                been moved. Please check the URL or return to the homepage.
              </p>
               <NavLink
                className="contact-btn d-flex align-items-center f-w-600 f-s-14 l-h-100"
                to={RoutesPaths.CONTACT}
              >
                <span className="btn-text">{t("common.cta.contact")}</span>
                <span className="arrow-circle">
                  <img src="/images/right-angle-arrow.png" alt="icon" />
                </span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}